<template>

  <v-expansion-panels v-model="panels"
                      :multiple="multiple"
                      :active-class="activeClass"
                      v-bind="$attrs"
                      @click.native="handleClick"
                      accordion>
    <v-expansion-panel v-for="(item,idx) in items"
                       :key="idx">

      <v-expansion-panel-header class="default-header"
                                v-on-hover-color="{color: onHoverColor, disabled: disableHover}"

                                v-bind:expansion-panel="item.id">
        <span v-if="useDefaultHeader && item.name" class="panel-title">
          {{item.name}}
        </span>

        <template slot="actions">
          <v-layout align-start justify-start column fill-height>
            <v-icon :class="iconClass">
              icon-caret-down
            </v-icon>
          </v-layout>
        </template>

        <slot name="main-title" class="panel-title"/>

        <slot name="title"
              :item="item"
              :idx="idx"
              :panels="panels"/>

      </v-expansion-panel-header>

      <slot name="header"
            :item="item"
            :idx="idx"
            :panels="panels"/>

      <v-expansion-panel-content>
        <slot name="content"
              :item="item"
              :idx="idx"
              :panels="panels"/>
      </v-expansion-panel-content>

    </v-expansion-panel>
  </v-expansion-panels>

</template>

<script>
  export default {
    name: 'ExpansionPanels',
    props: {
      items: {
        type: Array,
        required: true
      },
      activePanels: {
        type: Array,
        default: () => { return [] }
      },
      activeClass: {
        type: String,
        default: ""
      },
      direction: {
        type: String,
        default: 'ltr'
      },
      onHoverColor: {
        type: String
      },
      disableHover: {
        type: Boolean,
        default: true
      },
      multiple: {
        type: Boolean,
        default: true
      },
      useDefaultHeader: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        panels: [],
        oldPanels: [],
      }
    },
    created() {
      if (!this.activePanels.length) return;

      if (this.multiple) {
        this.activePanels.forEach((panel) => {
          let index = this.items.findIndex(item => panel === item.id);
          index >= 0 && this.panels.push(index);
        });
      } else {
        this.panels = this.items.findIndex(item => this.activePanels[0] === item.id);
      }
    },
    methods: {
      collapseAll() { // Can be called from the outside
        this.panels = [];
      },
      expandAll() { // Can be called from the outside
        const allPanels = [];
        this.items.forEach((value, index) => allPanels.push(index));
        this.panels = allPanels;
      },
      async handleClick(e) {
        await this.$nextTick()
        if (this.panels && this.oldPanels && this.panels.length > this.oldPanels.length) {
          this.$emit('click-expansion')
          this.oldPanels = this.panels
        }
      }
    },
    computed: {
      iconClass() {
        return this.$vuetify.rtl ? 'rtl-icon' : 'ltr-icon';
      }
    },
    watch: {
      panels: function(newVal, oldVal) {
        this.$emit('panel-change', newVal, oldVal);
        this.oldPanels = oldVal
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .v-icon {
    position: absolute;
    @include i-position-mirror(left, 10px);
    top: 10px;
    font-style: normal;
    padding: 3px;
    transform: rotate(-90deg);
    font-size: 20px;

    &.ltr-icon {
      transform: rotate(-90deg);
    }

    &.rtl-icon {
      transform: rotate(90deg);
    }
  }

  .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: $navy-color-1;
  }

  .v-expansion-panel--active>.v-expansion-panel-header--active .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate) .v-icon {
    transform: none;
  }

  .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: 48px;
  }

  .v-expansion-panel-header {
    color: $color_dark_text;
    @include i-padding-mirror(32px, 24px);
    font-weight: 600;
    font-size: 14px;
    transition: color 0.2s;
  }

  .v-expansion-panels {
    position: initial;
  }

  .v-expansion-panel {
    padding: 10px;
  }

  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 15px 15px;
  }

  .v-expansion-panel-content {
    font-size: 12px;
    font-weight: 400;
  }

</style>
